import React from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";

export function LastNameField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  return (
    <InputControl
      fieldId="lastName"
      fieldName="lastName"
      fieldTitlePhraseKey="payment_step.field_labels.last_name"
      fieldType="text"
      formMethods={formMethods}
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required"}
      attributes={{
        disabled: disabled,
        autoCorrect: "off",
        autoComplete: "family-name",
        "data-lpignore": "true"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.required, validators.invalidChars, validators.maxLength(32)]}
    />
  );
}

export default LastNameField;
